import { IS_DEV, IS_STAGING } from '../constants';
import { DEV_CLIENT_URL, STAGING_CLIENT_URL, PROD_CLIENT_URL } from '../constants/sso';

export function getClientUrl() {
    if (IS_DEV) {
        return DEV_CLIENT_URL;
    } else if (IS_STAGING) {
        return STAGING_CLIENT_URL;
    } else {
        return PROD_CLIENT_URL;
    }
}



// WEBPACK FOOTER //
// ./src/utils/ssoUtil.js